import { render, staticRenderFns } from "./NewCourse.vue?vue&type=template&id=ff70894a&scoped=true&"
import script from "./NewCourse.vue?vue&type=script&lang=js&"
export * from "./NewCourse.vue?vue&type=script&lang=js&"
import style0 from "./NewCourse.vue?vue&type=style&index=0&id=ff70894a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff70894a",
  null
  
)

export default component.exports